import { TrueAnswersComponent } from "./true-answers/true-answers.component";
import { AuthGuard } from "./auth.guard";
import { LoginComponent } from "./login/login.component";
import { AllMatComponent } from "./all-mat/all-mat.component";
import { QuizComponent } from "./quiz/quiz.component";
import { MatComponent } from "./mat/mat.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PickComponent } from "./pick/pick.component";

const routes: Routes = [
  { path: "", redirectTo: "all-mat", pathMatch: "full" },
  { path: "pick", component: PickComponent, canActivate: [AuthGuard] },
  // { path: "mat", component: MatComponent, canActivate: [AuthGuard] },
  { path: "quiz", component: QuizComponent, canActivate: [AuthGuard] },
  { path: "all-mat", component: AllMatComponent, canActivate: [AuthGuard] },
  { path: "login", component: LoginComponent },
  {
    path: "true-answers",
    component: TrueAnswersComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
